import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['a', 'address', 'b', 'blockquote', 'br', 'caption', 'code', 'col', 'colgroup', 'dd', 'div', 'dl', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'hr', 'i', 'li', 'ol', 'p', 'pre', 's', 'small', 'span', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul'];
const CSP = "default-src 'none'; img-src 'none'; style-src 'unsafe-inline'";
const OWNED_STYLE = 'body{font:15px/1.55 system-ui,sans-serif;color:#172033;margin:18px;overflow-wrap:anywhere}table{border-collapse:collapse;max-width:100%}td,th{border:1px solid #d7dce5;padding:6px;text-align:left}pre{white-space:pre-wrap}a{color:#174ea6}';

function normalizedHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR: ['href', 'title', 'colspan', 'rowspan'] });
  const root = document.createElement('div'); root.innerHTML = clean;
  root.querySelectorAll('a').forEach(link => {
    const href = link.getAttribute('href') || '';
    if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) link.removeAttribute('href');
    link.setAttribute('target', '_blank'); link.setAttribute('rel', 'noopener noreferrer');
  });
  return root.innerHTML;
}

export default function CafMessageBody({ html, text }: { html: string | null; text: string | null }) {
  const safe = useMemo(() => html ? normalizedHtml(html) : '', [html]);
  if (!safe) return <pre className="caf-plain-body">{text || 'No message body available.'}</pre>;
  const srcDoc = `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="${CSP}"><style>${OWNED_STYLE}</style></head><body>${safe}</body></html>`;
  return <div className="caf-message-body"><p className="caf-image-notice">Images have been blocked for privacy, including inline CID images.</p><iframe title="Email body" sandbox="" srcDoc={srcDoc} /></div>;
}
